import { useContext, useEffect } from "react";
import productosContext from "../context/productos/productosContext";

export const useProductos = () => {
    const {
        productos,
        producto,
        cart,
        orden,
        ordenes,
        postOrdenes,
        getOrdenes,
        getOrden,
        getProductos,
        getProducto,
        postProducto,
        putProducto,
        deleteProducto,
        addCart,
        getCart,
        removeCart
    } = useContext(productosContext);

    useEffect(() => {
        getProductos();
    }, []);

    



    const formatoCOP = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });

    return {
        productos,
        producto,
        cart,
        orden,
        ordenes,
        postOrdenes,
        getOrdenes,
        getOrden,
        getProductos,
        getProducto,
        postProducto,
        putProducto,
        deleteProducto,
        addCart,
        getCart,
        removeCart,
        formatoCOP
    }
}
